<template>
    <v-layout row class="sort-selector" :class="isDateSortInMobileApp ? 'sort-selector--adjusted-width' : ''">
        <v-flex class="flex-grow-overwrite">{{memberDirectoryPageConstant.label.SORT_BY}}</v-flex>
        <v-flex>
            <v-menu offset-y class="ypo_cta_blue_color"
                    nudge-left="70"
                    nudge-bottom="10">
                <v-flex slot="activator" class="sort-selection" data-qe-id="member-directory_sort-by_label">
                    {{currentSort.label}}
                    <v-icon size="19">arrow_drop_down</v-icon>
                </v-flex>
                <v-list class="sort-selector__options">
                    <v-list-tile
                            v-for="(sort, index) in sortOptions"
                            :key="sort.key"
                            :data-qe-id="`member-directory_sort-by_option-${index}`"
                            @click="currentSort = sort">
                        {{sort.label}}
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-flex>
    </v-layout>
</template>
<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import { storeGetters } from "../../../store/storeGetters.constant";
    import { storeAction } from "../../../store/storeActions.constant";
    import { sortOptions, memberDirectoryPageConstant } from '../memberDirectoryPage.constants';
    import { storeMutation } from "../../../store/storeMutations.constant";
    import { removeLetterFilterForRolodex } from "../../EventDirectoryPage/eventDirectoryPage.constants";


    export default {
        name: 'SortByOptions',
        data() {
            return {
                memberDirectoryPageConstant,
                sortOptions,
            };
        },
        props: {
            directoryStoredFilterConstant: {
                type: String,
                required: true,
            },
        },
        watch: {
            currentSort() {
                this.setMemberSelectedLetterFilter();
                removeLetterFilterForRolodex(
                    this.$route.query,
                    this.$router,
                    this.directoryStoredFilterConstant,
                );
                const additionalFiltersFromRoute = this.$route.query.additionalFilters ? JSON.parse(this.$route.query.additionalFilters) : null;
                this.getInitialMemberDirectoryResult(additionalFiltersFromRoute);
            },
        },
        methods: {
            ...mapActions({
                getInitialMemberDirectoryResult: `memberDirectory/${storeAction.getInitialMemberDirectorySearchResults}`,
            }),
            ...mapMutations({
                setMemberDirectorySort: `memberDirectory/${storeMutation.setMemberDirectorySort}`,
                setMemberSelectedLetterFilter: `memberDirectory/${storeMutation.setMemberSelectedLetterFilter}`,
            }),
            close() {
                this.handleClose(this.pillItem);
            },
        },
        computed: {
            ...mapGetters({
                memberDirectorySort: `memberDirectory/${storeGetters.memberDirectorySort}`,
                isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
            }),
            currentSort: {
                get() {
                    return this.memberDirectorySort;
                },
                set(value) {
                    this.setMemberDirectorySort(value);
                },
            },
            isDateSortInMobileApp() {
                return this.currentSort
                    && this.currentSort.sortField
                    && this.currentSort.sortField.toLowerCase() === memberDirectoryPageConstant.constant.companyNameSort.toLowerCase()
                    && this.isMobileAppBrowser;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .sort-selector {
        background-color: $ypo-tile-bgcolor;
        line-height: 24px;
        width: 210px;
        padding: 10px;

        &--adjusted-width {
            width: 225px !important;
        }

        @include breakpoint(xs) {
            padding: 10px 5px;
            width: 190px;
        }

        & > * {
            vertical-align: middle;
        }

        &__options {
            width: 180px;
        }

        .v-menu {
            width: 100%;

        }

    }

    .sort-selection {
        padding-left: 5px;
        margin-top: -3px;
        position: relative;

        .v-icon {
            color: $ypo-cta;
            position: absolute;
            right: 0;
            bottom: 2px;
        }
    }
</style>

